var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{attrs:{"id":_vm.componentId}})
}
var staticRenderFns = []

export { render, staticRenderFns }